import { render, staticRenderFns } from "./contentCourseLiveEdit.vue?vue&type=template&id=ed0b5378&"
import script from "./contentCourseLiveEdit.vue?vue&type=script&lang=js&"
export * from "./contentCourseLiveEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports